import 'block.product-variant-picker'
import 'product.gallery'
import { EVENTS } from 'util.events'

class IiHm20ProductImages extends customElements.get('product-images') {
  connectedCallback() {
    super.connectedCallback()
    this.selectVariantMedia(this.currentVariant)
  }

  initProductSlider(variant) {
    if (this.flickity) {
      this.flickity.destroy()
      this.flickity = null
    }
    // Group filtering can reorder cells; retain the source order used by thumbnails.
    const slides = [...this.cache.mainSlider.querySelectorAll('.product-main-slide')]
    slides.sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index))
    slides.forEach(slide => this.cache.mainSlider.append(slide))
    super.initProductSlider(variant)
  }

  updateVariantImage(event) {
    if (event.detail.loading || !event.detail.variant?.featured_media) return
    const variant = event.detail.variant
    // Rebuild the colour group before selecting; never animate cells being replaced.
    if (this.settings.imageSetIndex) super.updateImageSet(event)
    this.selectVariantMedia(variant)
  }

  selectVariantMedia(variant) {
    if (!variant?.featured_media) return
    const slider = this.flickity?.slideshow
    const index = slider?.cells.findIndex(cell => cell.element.dataset.mediaId === String(variant.featured_media.id))
    if (index >= 0) slider.select(index, false, true)
  }

  updateImageSet(event) {
    if (!event.detail.loading) super.updateImageSet(event)
  }
}

if (!customElements.get('ii-hm20-product-images')) customElements.define('ii-hm20-product-images', IiHm20ProductImages)

class IiHm20VariantPicker extends customElements.get('block-variant-picker') {
  async handleVariantChange(event) {
    const revision = this.selectionRevision = (this.selectionRevision || 0) + 1
    this.updateOptions()
    this.updateMasterId(event.target)
    if ('dynamicVariantsEnabled' in this.dataset) this.updateVariantStatuses(event.target)
    this.updateColorNames()
    const variant = this.currentVariant
    const status = this.closest('[data-hm20-pilot]').querySelector('[data-hm20-status]')
    status.textContent = ''
    // The theme price listener expects a document, even during loading.
    const emit = (html, loading) => this.dispatchEvent(new CustomEvent(
      `${EVENTS.variantChange}:${this.dataset.sectionId}:${this.dataset.productId}`,
      { bubbles: true, detail: { sectionId: this.dataset.sectionId, html, variant, loading } }
    ))
    emit(document.implementation.createHTMLDocument(), Boolean(variant))
    if (!variant) return
    this.updateURL()
    try {
      const html = await this.getProductInfo()
      if (revision !== this.selectionRevision) return
      emit(html, false)
    } catch (error) {
      if (revision !== this.selectionRevision) return
      status.textContent = 'This finish could not be loaded. Choose it again or reload the page.'
      // Keep the native loading guard in place rather than submit stale information.
      console.warn('HM20 finish information unavailable', error)
    }
  }

  pilotURL(variantId) {
    const url = new URL(this.dataset.url, location.origin)
    const current = new URL(location.href)
    for (const key of ['view', 'preview_theme_id', 'pb']) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key))
    }
    url.searchParams.set('variant', variantId)
    return url
  }

  updateURL() {
    if (!this.currentVariant || !('updateUrl' in this.dataset)) return
    history.replaceState({}, '', this.pilotURL(this.currentVariant.id))
  }

  getProductInfo() {
    const id = this.currentVariant.id
    if (!this.productInfo.has(id)) {
      const url = this.pilotURL(id)
      const request = fetch(url).then(response => {
        if (!response.ok) throw new Error('Product information could not be loaded')
        return response.text()
      }).then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html')
        if (!parsed.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`)) {
          throw new Error('Pilot product form missing from response')
        }
        return parsed
      })
      this.productInfo.set(id, request)
      request.catch(() => this.productInfo.delete(id))
    }
    return this.productInfo.get(id)
  }
}

if (!customElements.get('ii-hm20-variant-picker')) customElements.define('ii-hm20-variant-picker', IiHm20VariantPicker)

